module.exports = __webpack_public_path__ + "static/media/Offer-Light.e7916a04.svg";